import { render, staticRenderFns } from "./ProductVariantEdit.vue?vue&type=template&id=38b4abd6"
import script from "./ProductVariantEdit.vue?vue&type=script&lang=js"
export * from "./ProductVariantEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports